/**
 * ╔══════════════════════════════════════════════════════════╗
 * ║  LIBERSELL — Urgencia y Prueba Social                   ║
 * ║  DÓNDE SUBIR:                                           ║
 * ║  Online Store > Themes > Edit Code > Assets             ║
 * ║  Crea un nuevo archivo: libersell-urgency.js            ║
 * ║  Luego en theme.liquid, antes de </body>, agrega:       ║
 * ║    <script src="{{ 'libersell-urgency.js' | asset_url }}" defer></script>
 * ║                                                         ║
 * ║  En cada página de producto agrega estos atributos:     ║
 * ║  <span data-ls-viewers></span>                          ║
 * ║  <div data-ls-stock data-qty="{{ product.selected_or_first_available_variant.inventory_quantity }}"></div>
 * ╚══════════════════════════════════════════════════════════╝
 */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     1. CONTADOR DE PERSONAS VIENDO EL PRODUCTO
  ────────────────────────────────────────────────────────── */
  function initViewers() {
    document.querySelectorAll('[data-ls-viewers]').forEach(function (el) {
      var count = Math.floor(Math.random() * 10) + 3;
      el.innerHTML = '<span class="ls-eye">👁</span> <strong>' + count + '</strong> personas están viendo este producto ahora';
      el.className = 'ls-viewers-badge';

      setInterval(function () {
        var delta = Math.random() > 0.5 ? 1 : -1;
        count = Math.max(2, Math.min(18, count + delta));
        el.querySelector('strong').textContent = count;
      }, Math.random() * 15000 + 15000);
    });
  }

  /* ──────────────────────────────────────────────────────────
     2. BADGE DE STOCK BAJO
  ────────────────────────────────────────────────────────── */
  function initStockBadge() {
    document.querySelectorAll('[data-ls-stock]').forEach(function (el) {
      var qty = parseInt(el.getAttribute('data-qty') || '99', 10);
      if (qty > 0 && qty <= 10) {
        el.innerHTML = '⚠️ ¡Solo quedan <strong>' + qty + ' unidades</strong> disponibles!';
        el.className = 'ls-stock-badge ls-stock-low';
        el.style.display = 'block';
      } else if (qty === 0) {
        el.innerHTML = '❌ Agotado por el momento';
        el.className = 'ls-stock-badge ls-stock-out';
        el.style.display = 'block';
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     3. NOTIFICACIONES TOAST DE COMPRAS RECIENTES
  ────────────────────────────────────────────────────────── */
  var BUYERS = [
    { name: 'María G.',    city: 'Guayaquil',  product: 'Faja Postparto',          time: 'hace 4 min'   },
    { name: 'Carlos R.',   city: 'Quito',      product: 'Impresora Bluetooth',      time: 'hace 11 min'  },
    { name: 'Ana L.',      city: 'Cuenca',     product: 'Organizador de Zapatos',   time: 'hace 18 min'  },
    { name: 'Pedro S.',    city: 'Ambato',     product: 'Escurridor de Platos',     time: 'hace 26 min'  },
    { name: 'Laura M.',    city: 'Manta',      product: 'Micro SD 128GB',           time: 'hace 34 min'  },
    { name: 'Diego F.',    city: 'Loja',       product: 'Faja Postquirúrgica',      time: 'hace 47 min'  },
    { name: 'Valeria T.',  city: 'Portoviejo', product: 'Organizador de Zapatos',   time: 'hace 52 min'  },
    { name: 'Roberto H.',  city: 'Riobamba',   product: 'Impresora Bluetooth',      time: 'hace 1 hora'  },
    { name: 'Sofía P.',    city: 'Quito',      product: 'Micro SD 128GB',           time: 'hace 1 hora'  },
    { name: 'Andrés V.',   city: 'Guayaquil',  product: 'Escurridor de Platos',     time: 'hace 2 horas' },
  ];

  function injectToastStyles() {
    if (document.getElementById('ls-toast-css')) return;
    var css = [
      '#ls-toast{position:fixed;bottom:20px;left:20px;z-index:88888;',
        'background:#fff;border-radius:14px;padding:14px 18px 14px 14px;',
        'box-shadow:0 6px 32px rgba(0,0,0,.18);display:flex;align-items:flex-start;',
        'gap:12px;max-width:320px;border-left:4px solid #4CAF50;',
        'font-size:14px;line-height:1.45;color:#333;',
        'animation:lsToastIn .4s cubic-bezier(.34,1.2,.64,1) both;}',
      '@keyframes lsToastIn{from{transform:translateX(-120%);opacity:0}to{transform:translateX(0);opacity:1}}',
      '@keyframes lsToastOut{to{transform:translateX(-120%);opacity:0}}',
      '.ls-toast-icon{font-size:26px;flex-shrink:0;margin-top:1px}',
      '.ls-toast-close{position:absolute;top:8px;right:10px;background:none;',
        'border:none;color:#ccc;cursor:pointer;font-size:15px;line-height:1;padding:0}',
      '.ls-toast-time{font-size:12px;color:#999;display:block;margin-top:2px}',
      '@media(max-width:480px){#ls-toast{left:10px;right:10px;max-width:none}}',

      /* ── Viewers badge ── */
      '.ls-viewers-badge{display:flex;align-items:center;gap:6px;',
        'font-size:14px;color:#555;margin:10px 0;padding:8px 12px;',
        'background:#f0f4ff;border-radius:8px;border:1px solid #dce4ff;}',

      /* ── Stock badge ── */
      '.ls-stock-badge{padding:8px 14px;border-radius:8px;font-size:14px;margin:10px 0;display:none}',
      '.ls-stock-low{background:#fff3e0;color:#e65100;border:1px solid #ffcc80;}',
      '.ls-stock-out{background:#fce4ec;color:#b71c1c;border:1px solid #f48fb1;}',
    ].join('');
    var tag = document.createElement('style');
    tag.id  = 'ls-toast-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function showToast(data) {
    var old = document.getElementById('ls-toast');
    if (old) { old.style.animation = 'lsToastOut .3s ease forwards'; setTimeout(function(){ if(old.parentNode) old.remove(); }, 300); }

    setTimeout(function () {
      var t = document.createElement('div');
      t.id = 'ls-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML =
        '<div class="ls-toast-icon">🛒</div>' +
        '<div><strong>' + data.name + '</strong> en <strong>' + data.city + '</strong>' +
        ' acaba de comprar <em>' + data.product + '</em>' +
        '<span class="ls-toast-time">⏱ ' + data.time + '</span></div>' +
        '<button class="ls-toast-close" onclick="this.parentElement.remove()" aria-label="Cerrar">✕</button>';
      document.body.appendChild(t);
      setTimeout(function () {
        if (t.parentNode) {
          t.style.animation = 'lsToastOut .3s ease forwards';
          setTimeout(function() { if(t.parentNode) t.remove(); }, 300);
        }
      }, 7000);
    }, old ? 350 : 0);
  }

  function startToasts() {
    injectToastStyles();
    var idx = Math.floor(Math.random() * BUYERS.length);
    setTimeout(function tick() {
      showToast(BUYERS[idx % BUYERS.length]);
      idx++;
      setTimeout(tick, Math.random() * 30000 + 30000); // cada 30–60s
    }, 18000); // primera a los 18s
  }

  /* ──────────────────────────────────────────────────────────
     4. TEXTO ROTATIVO EN BOTÓN "AGREGAR AL CARRITO"
  ────────────────────────────────────────────────────────── */
  function initCartButton() {
    var btn = document.querySelector('[name="add"]:not([disabled])');
    if (!btn) return;
    var original = btn.textContent.trim();
    var msgs = [
      original,
      '✅ Envío gratis incluido',
      original,
      '⚡ Entrega 24-48h en Ecuador',
    ];
    var i = 0;
    setInterval(function () {
      i = (i + 1) % msgs.length;
      btn.textContent = msgs[i];
    }, 3200);
  }
  /* ──────────────────────────────────────────────────────────
     INIT
  ────────────────────────────────────────────────────────── */
  function init() {
    injectToastStyles();
    initShippingBar();
    initViewers();
    initStockBadge();
    startToasts();

    var isProduct = document.querySelector('[data-product-id], .product-page, form[action*="/cart/add"]');
    if (isProduct) initCartButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
